import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-header',
  imports: [CommonModule, ButtonModule, LineBreakPipe],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  logoItem: any = null;
  headerImageItem: any = null;
  headlineItem: any = null;
  descriptionItem: any = null;
  titleItem: any = null;
  paragraphItem: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }

    this.logoItem = this.findByLabel(['Logo'], 0);
    this.headerImageItem = this.findByLabel(
      ['Header Image', 'Image'],
      1,
    );
    this.headlineItem = this.findByLabel(
      ['Headline', 'Authentic'],
      2,
    );
    this.descriptionItem = this.findByLabel(
      ['Description', 'Subheading'],
      3,
    );
    this.titleItem = this.findByLabel(['Title'], 4);
    this.paragraphItem = this.findByLabel(
      ['Paragraph', 'Product Description'],
      5,
    );
  }

  private findByLabel(
    labels: string[],
    fallbackIndex?: number,
  ): any {
    const found = this.items.find((item: any) =>
      labels.includes(item?.label),
    );
    if (found) {
      return found;
    }
    if (
      typeof fallbackIndex === 'number' &&
      fallbackIndex >= 0 &&
      fallbackIndex < this.items.length
    ) {
      return this.items[fallbackIndex];
    }
    return null;
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }
}
